<template>
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col xl="6" lg="6" md="6" cols="12" class="pb-0">
          <v-text-field
            label="Data inicial"
            type="date"
            :max="dtFinal"
            v-model="dtInicial"
          ></v-text-field>
        </v-col>
        <v-col xl="6" lg="6" md="6" cols="12" class="pb-0">
          <v-text-field
            label="Data final"
            type="date"
            :min="dtInicial"
            :max="dtHoje"
            v-model="dtFinal"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="green"
        class="mb-2"
      ></v-progress-linear>
      <v-row class="mt-0">
        <v-col xl="4" lg="4" md="4" cols="12">
          <v-card outlined rounded="lg">
            <v-card-title class="font-weight-bold subtitle-1"
              >Última compra</v-card-title
            >
            <v-card-text>
              <v-list-item class="grey lighten-3 rounded-lg">
                <v-list-item-content>
                  <v-list-item-subtitle>Data NF</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    formatarData(resumoCompras.dtultcompra)
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="grey lighten-3 rounded-lg mt-2">
                <v-list-item-content>
                  <v-list-item-subtitle>Nº Nota Fiscal</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    resumoCompras.nfultcompra
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="grey lighten-3 rounded-lg mt-2">
                <v-list-item-content>
                  <v-list-item-subtitle>Valor</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    formatarMoeda(resumoCompras.vlrultcompra)
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col xl="4" lg="4" md="4" cols="12">
          <v-card outlined rounded="lg">
            <v-card-title class="font-weight-bold subtitle-1"
              >Maior compra</v-card-title
            >
            <v-card-text>
              <v-list-item class="grey lighten-3 rounded-lg">
                <v-list-item-content>
                  <v-list-item-subtitle>Data NF</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    formatarData(getInfoHistorico().dtmaiorcompra)
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="grey lighten-3 rounded-lg mt-2">
                <v-list-item-content>
                  <v-list-item-subtitle>Nº Nota Fiscal</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    getInfoHistorico().nfmaiorcompra
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="grey lighten-3 rounded-lg mt-2">
                <v-list-item-content>
                  <v-list-item-subtitle>Valor</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    formatarMoeda(getInfoHistorico().vlrmaiorcompra)
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col xl="4" lg="4" md="4" cols="12">
          <v-card outlined flat rounded="lg">
            <v-card-title class="font-weight-bold subtitle-1"
              >Resumo total compras</v-card-title
            >
            <v-card-text>
              <v-list-item class="grey lighten-3 rounded-lg">
                <v-list-item-content>
                  <v-list-item-subtitle
                    >Quantidade de compras</v-list-item-subtitle
                  >
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    getInfoHistorico().qtdecompras
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="grey lighten-3 rounded-lg mt-2">
                <v-list-item-content>
                  <v-list-item-subtitle
                    >Valor total de compras</v-list-item-subtitle
                  >
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    formatarMoeda(getInfoHistorico().vlrtotal)
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="grey lighten-3 rounded-lg mt-2">
                <v-list-item-content>
                  <v-list-item-subtitle
                    >Valor médio de compra</v-list-item-subtitle
                  >
                  <v-list-item-title class="font-weight-bold mt-1">{{
                    formatarMoeda(getInfoHistorico().vlrmedio)
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
import { formatMoeda } from "@/global";
export default {
  props: {
    perfil: Object,
  },
  data() {
    return {
      resumoCompras: this.perfil.resumocompras,
      dtHoje: moment().format("YYYY-MM-DD"),
      dtInicial: moment().subtract(1, "year").format("YYYY-MM-DD"),
      dtFinal: moment().format("YYYY-MM-DD"),
      loading: false,
    };
  },
  watch: {
    dtInicial() {
      this.carregarResumo();
    },
    dtFinal() {
      this.carregarResumo();
    },
  },
  methods: {
    ...mapActions("clientes", ["getPerfil"]),
    formatarData(value) {
      if (!value || !moment(value).isValid() || moment(value).year() <= 1) {
        return "-";
      }
      return moment(value).format("DD/MM/YYYY");
    },
    formatarMoeda(value) {
      return formatMoeda(value);
    },
    getInfoHistorico() {
      const historico = this.resumoCompras.historico || [];
      return historico.find((his) => his.ano == 1) || historico[0] || {};
    },
    async carregarResumo() {
      if (!this.dtInicial || !this.dtFinal || this.dtInicial > this.dtFinal) {
        return;
      }
      this.loading = true;
      const perfis = await this.getPerfil({
        matricula: this.perfil.matricula,
        dtinicial: this.dtInicial,
        dtfinal: this.dtFinal,
      });
      if (perfis.length > 0) {
        this.resumoCompras = perfis[0].resumocompras;
      }
      this.loading = false;
    },
  },
};
</script>

<style></style>
